module.exports = __webpack_public_path__ + "media/images/icons/account-logout-f31fbec1300649300734bf9e644801e3.svg";